<template>
    <div id="loginDiv">
        <!-- Login Model -->
        <div ref="loginModel" class="modal fade login-box" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Login</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!--<p class="no-mar-top green-color">Welcome back</p>-->
                        <p class="no-mar-top red-color" v-if="login.error">{{login.errormsg}}</p>
                        <p class="no-mar-top green-color" v-if="login.successmsg">{{login.successmsg}}</p>
                        <h4 class="no-mar-top green-color" v-if="login.otp_send === 2">{{login.username}}</h4>
                        
                        <div class="form-content line-textbox">
                            <form data-vv-scope="login" v-show="login.otp_send === 1">
                                <div class="form-group" v-if="!login.login_with_otp">
                                    <input class="form-control" type="text" ref="login_username" name="username" id="username" data-vv-as="email or mobile" v-model="login.username" v-validate="'required'" placeholder="Email or Mobile Number" >
                                    <span v-show="errors.has('login.username')" class="text-danger">{{ errors.first('login.username') }}</span>
                                </div>
                                <div class="form-group" v-else>
                                    <input class="form-control" type="text" ref="login_username" v-mask="'##########'" name="username" id="username" data-vv-as="mobile" v-model="login.username" v-validate="'required'" placeholder="Mobile Number" >
                                    <span v-show="errors.has('login.username')" class="text-danger">The mobile number field is required.</span>
                                </div>
                                <div class="form-group  mb-2" v-if="!login.login_with_otp">
                                    <input class="form-control" type="password" ref="login_password"  name="password" id="password" data-vv-as="password" v-model="login.password" v-validate="'required'" placeholder="Password" >
                                    <span v-show="errors.has('login.password')" class="text-danger">{{ errors.first('login.password') }}</span>
                                </div>
                                <div class="form-group  mb-2" v-else>
                                    <input class="form-control" type="password" placeholder="Password" disabled>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mb-3 text-center signup-link float-right display-block" data-target=".forgot" data-backdrop="static" data-keyboard="false">
                                        Forgot Password?
                                    </a>
                                  </div>
                                  <div class="col-sm-12 mb-3">
                                    <label class="checkbox_container">Login With OTP?
                                      <input type="checkbox" ref="login_with_otp"  name="login_with_otp" id="login_with_otp" data-vv-as="login_with_otp" v-model="login.login_with_otp">
                                      <span class="checkbox_checkmark"></span>
                                    </label>
                                  </div>
                                </div>
                                <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="loginClicked()" >{{!login.login_with_otp ? 'Login' : 'Send OTP'}}</button>
                                <div class="blue-border rounded p-2 text-center full-width f-14 mb-3">
                                  New User?
                                  <a data-dismiss="modal" data-toggle="modal" href="#lost" class="blue-color" data-target=".signup" data-backdrop="static" data-keyboard="false" @click="clearFields(1)">
                                      Signup
                                  </a>
                              </div>
                            </form>
                            <form data-vv-scope="login-wt-otp" v-show="login.otp_send === 2" >
                                <div class="form-group  mb-2">
                                    <input class="form-control" type="text" ref="login_otp" name="login_otp" id="login_otp" maxlength="6" v-model="login.login_otp" data-vv-as="OTP" v-mask="'##########'" v-validate="'required'" placeholder="Enter your OTP" >
                                    <span v-show="errors.has('login-wt-otp.login_otp')" class="text-danger">{{ errors.first('login-wt-otp.login_otp') }}</span>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <a @click="clearFields()" class="mb-3 text-center signup-link blue-color" >
                                        Back to Login?
                                    </a>
                                     <!--<a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mb-3 text-center signup-link float-right display-block" data-target=".forgot" data-backdrop="static" data-keyboard="false">
                                        Forgot Password?
                                    </a>-->
                                    <a class="mb-3 text-center signup-link float-right display-block resent_otp" v-on:click="loginWithOtpChanged(true)">Resend OTP?</a>
                                  </div>
                                </div>
                                <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="verifyLoginOTP()" >Verify OTP</button>
                            </form>
                            <!-- <button class="btn btn-outline-secondary full-width" data-dismiss="modal" data-toggle="modal" href="#lost" data-target=".login-otp" data-backdrop="static" data-keyboard="false">Login Without Password</button> -->
                            
                            <!--<div class="row mt-0">
                                <div class="col-sm-6">
                                     <a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mar-t-15 text-center signup-link display-block" data-target=".forgot" data-backdrop="static" data-keyboard="false">
                                        Forgot Password?
                                    </a>
                                </div>
                                <div class="col-sm-6">
                                     <a data-dismiss="modal" data-toggle="modal" href="#lost" class="mar-t-15 text-center signup-link display-block" data-target=".signup" data-backdrop="static" data-keyboard="false" @click="clearFields(1)">
                                        Create Account?
                                    </a>
                                </div>
                            </div>-->
                            <div v-if="otherSignup">
                                <p>Or Login Using</p>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <button class="btn full-width facebook-btn mar-b-15">
                                            <span class="fa fa-facebook-official"></span> Facebook
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn full-width google-btn">
                                            <span class="fa fa-google-plus-square"></span> Google+
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sign Up Model -->
        <div class="modal fade signup" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Sign Up</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <p class="no-mar-top">Create an account on Labotist</p>
                        <p class="no-mar-top red-color" v-if="signup.error">{{signup.errormsg}}</p>
                        <p class="no-mar-top green-color" v-if="signup.success">{{signup.successmsg}}</p>
                        <div class="form-content line-textbox">
                            <form data-vv-scope="signup" v-show="!signup.success">
                                <div class="form-group">
                                    <input class="form-control" ref="signUpEmail" type="email" name="email" data-vv-as="email address" v-model="signup.email" maxlength="100" v-validate="'required|email|max:100'" placeholder="Email address">
                                    <span v-show="errors.has('signup.email')" class="text-danger">{{ errors.first('signup.email') }}</span>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" ref="signUpMobile"  type="text" name="mobile" v-mask="'##########'" data-vv-as="mobile no." v-model="signup.mobile" v-validate="'required|numeric|min:10|max:10'" placeholder="Mobile number">
                                    <span v-show="errors.has('signup.mobile')" class="text-danger">{{ errors.first('signup.mobile') }}</span>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" type="text" name="firstName" data-vv-as="first name" v-model="signup.firstName" maxlength="50" v-validate="'required|alpha_spaces|max:50'" placeholder="Name">
                                    <span v-show="errors.has('signup.firstName')" class="text-danger">{{ errors.first('signup.firstName') }}</span>
                                </div>
                                <!--<div class="form-group">
                                    <input class="form-control" type="text" name="lastName" data-vv-as="last name" v-model="signup.lastName" maxlength="50" v-validate="'required|alpha_spaces|max:50'" placeholder="Last Name">
                                    <span v-show="errors.has('signup.lastName')" class="text-danger">{{ errors.first('signup.lastName') }}</span>
                                </div>-->
                                <div class="form-group">
                                    <input class="form-control" type="password" name="password" data-vv-as="password" v-model="signup.password" v-validate="'required'" placeholder="Password">
                                    <span v-show="errors.has('signup.password')" class="text-danger">{{ errors.first('signup.password') }}</span>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" type="text" name="referralCode" ref="referralCode" data-vv-as="referralCode" v-model="signup.referralCode" v-validate="'alpha_num|max:8'" placeholder="Referral Code(Optional)" :disabled="referralCodeDisable">
                                    <span v-show="errors.has('signup.referralCode')" class="text-danger">{{ errors.first('signup.referralCode') }}</span>
                                </div>
                                <!--<div class="form-group">
                                    <label>Gender</label>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="signup.sex"> Male
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="signup.sex"> Female
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="O" v-model="signup.sex"> Other
                                        </label>
                                    </div>
                                </div>-->
                                <!--<div class="form-group">
                                    <label>Date of birth</label>
                                    <div class="input-group dobBorderRemoval">
                                        <datepicker class="form-control" name="dob" :value="signup.dob" v-model="signup.dob" data-vv-as="date of birth" :format="'dd/MM/yyyy'" :disabled="disabled" v-validate="'required'"></datepicker>
                                        <span class="input-group-btn">
                                            <button class="btn btn-link white-bg" type="button">
                                                <img src="static/images/calender.svg" class="m-0" alt="">
                                            </button>
                                        </span>
                                    </div>
                                    <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                </div>-->
                                <!--<div class="form-group" >
                                  <label>Date of birth</label>
                                  <div class="row">
                                      <div class="col-4">
                                          <select class="form-control" name="year" id="year"  v-model="signup.year" v-on:change="getNumberOfDays()">
                                              <option value="" class="dobOptionColor" disabled selected>YYYY</option>
                                              <option v-for="(dobYear, index) in signup.dobYears" v-bind:value="dobYear" :key='index'>{{dobYear}}</option>
                                          </select>
                                      </div>
                                      <div class="col-4">
                                          <select class="form-control" name="month" id="month" v-model="signup.month" v-on:change="getNumberOfDays()">
                                              <option value="" class="dobOptionColor" disabled selected>MMM</option>
                                              <option value="01">Jan</option>
                                              <option value="02">Feb</option>
                                              <option value="03">Mar</option>
                                              <option value="04">Apr</option>
                                              <option value="05">May</option>
                                              <option value="06">Jun</option>
                                              <option value="07">Jul</option>
                                              <option value="08">Aug</option>
                                              <option value="09">Sep</option>
                                              <option value="10">Oct</option>
                                              <option value="11">Nov</option>
                                              <option value="12">Dec</option>
                                          </select>
                                      </div>
                                      <div class="col-4">
                                      <select class="form-control" name="day" id="day" v-model="signup.ddate">
                                          <option value="" class="dobOptionColor" disabled selected>DD</option>
                                          <option v-for="(dobDateVal, index) in signup.dobDate" v-bind:value="dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''" :key='index'>{{dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : '' }}</option>
                                      </select>
                                      </div>
                                      <div class="col-sm-12">
                                          <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                      </div>
                                  </div>
                                </div>-->
                                <button class="btn btn-primary full-width" type="submit" @click.prevent="create_account()">Continue</button>
                            </form>
                            <form data-vv-scope="signupOtp" v-show="signup.success">
                                <div class="form-group">
                                    <input class="form-control" type="text" name="sotp" data-vv-as="signup otp" v-model="signup.otp" v-validate="'required'" placeholder="Enter OTP">
                                    <span v-show="errors.has('signupOtp.sotp')" class="text-danger">{{ errors.first('signupOtp.sotp') }}</span>
                                </div>
                                <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="signup_verify_otp()">Verify</button>
                                <a class="text-center signup-link display-block" @click.prevent="signup_resend()">Resend?</a>
                            </form>
                            <a data-dismiss="modal" data-toggle="modal" href="#lost" class="mar-t-15 text-center signup-link display-block" data-target=".login-box" @click="clearFields()" data-backdrop="static" data-keyboard="false">Back to login?</a>
                            <div v-if="otherSignup">
                                <p>Or Signup Using</p>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <button class="btn full-width facebook-btn mar-b-15">
                                            <span class="fa fa-facebook-official"></span> Facebook
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn full-width google-btn">
                                            <span class="fa fa-google-plus-square"></span> Google+
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Forgot Model -->
        <div class="modal fade forgot" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" v-if="forgot.success === 1 || forgot.success === 2">Forgot Password</h5>
                        <h5 class="modal-title" id="exampleModalLabel" v-if="forgot.success === 3">Change Password</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <p class="no-mar-top" v-if="forgot.success === 1 || forgot.success === 2">Reset password through Email/Mobile</p>
                        <p class="no-mar-top" v-if="forgot.success === 3">Reset your Password</p>
                        <p class="no-mar-top red-color" v-if="forgot.error">{{forgot.errormsg}}</p>
                        <p class="no-mar-top green-color" v-if="forgot.success === 2">{{forgot.successmsg}}</p>
                        <h4 class="no-mar-top green-color" v-if="forgot.success === 2">{{forgot.username}}</h4>
                        <div class="form-content line-textbox">
                            <form data-vv-scope="forgot" v-show="forgot.success === 1">
                                <div class="row">
                                  <div class="col-sm-4">
                                    <input class="mr-3" type="radio" name="otp_type" id="otp_type_email" value="1" v-model="forgot.otpType"/><label for="otp_type_email" >Email</label>
                                  </div>
                                  <div class="col-sm-6">
                                    <input class="mr-3" type="radio" name="otp_type" id="otp_type_sms" value="2" v-model="forgot.otpType"/><label for="otp_type_sms" >Sms</label>
                                  </div>
                                </div>
                                <div class="form-group" v-if="forgot.otpType == 1">
                                    <input class="form-control" type="email" name="fusername" data-vv-as="email address" v-model="forgot.username" v-validate="'required|email'" placeholder="Email Address">
                                    <span v-show="errors.has('forgot.fusername')" class="text-danger">{{ errors.first('forgot.fusername') }}</span>
                                </div>
                                <div class="form-group" v-if="forgot.otpType == 2">
                                    <input class="form-control" type="text" v-mask="'##########'" name="fusername" data-vv-as="email address" v-model="forgot.username" v-validate="'required'" placeholder="Mobile Number">
                                    <span v-show="errors.has('forgot.fusername')" class="text-danger">Mobile number field is required.</span>
                                </div>
                                <button class="btn btn-primary full-width mt-3 mar-b-15" type="submit" @click.prevent="forgetPassword()">Send</button>
                            </form>
                            <form data-vv-scope="forgotOtp" v-show="forgot.success === 2">
                                <div class="form-group">
                                    <input class="form-control" type="text" v-mask="'######'" name="fotp" v-model="forgot.otp" data-vv-as="verify otp" v-validate="'required'" placeholder="Enter OTP">
                                    <span v-show="errors.has('forgotOtp.fotp')" class="text-danger">{{ errors.first('forgotOtp.fotp') }}</span>
                                </div>
                                <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="verify_otp">Verify</button>
                                <a class="text-center signup-link display-block" v-on:click="resend()">
                                    Resend?
                                </a>
                            </form>
                            <form data-vv-scope="resetPassword" v-show="forgot.success === 3">
                                <div class="form-group">
                                    <input class="form-control" type="password" name="newPassword" data-vv-as="new password" v-model="forgot.newPassword" v-validate="'required'"  placeholder="New Password">
                                    <span v-show="errors.has('resetPassword.newPassword')" class="text-danger">{{ errors.first('resetPassword.newPassword') }}</span>
                                </div>
                                <div class="form-group">
                                    <input class="form-control" type="password" name="confirmPassword" data-vv-as="password" v-model="forgot.confirmPassword" v-validate="'required'" placeholder="Confirm Password">
                                    <span v-show="errors.has('resetPassword.confirmPassword')" class="text-danger">{{ errors.first('resetPassword.confirmPassword') }}</span>
                                    <span v-show="forgot.confirmPassword !== '' && forgot.newPassword != forgot.confirmPassword" class="text-danger">Confirm password doesn't match</span>
                                </div>
                                <button class="btn btn-primary full-width mar-b-15" type="submit" @click.prevent="reset_password">Submit</button>
                            </form>
                            <a data-dismiss="modal" data-toggle="modal" href="#lost" @click="clearFields()" class="mar-t-15 text-center signup-link display-block" data-target=".login-box" data-backdrop="static" data-keyboard="false">
                                Back to login?
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Login Without Password Model -->
        <div class="modal fade login-otp" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Login with OTP</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <p class="no-mar-top">Login with otp</p>
                        <p class="no-mar-top green-color" v-show="false">Welcome back</p>
                        <div class="form-content line-textbox">
                            <div class="form-group">
                                <input class="form-control" type="text" placeholder="Email Address/Mobile No.">
                            </div>
                            <button class="btn btn-primary full-width mt-3 ">Send</button>
                            <a data-dismiss="modal" data-toggle="modal" @click="clearFields()" href="#lost" class="mar-t-15 text-center signup-link display-block" data-target=".login-box" data-backdrop="static" data-keyboard="false">
                                Continue to login?
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Vue from 'vue'
export default {
  name: 'Login',
  components: {
    Datepicker
  },
  data () {
    return {
      isDobError: false,
      otherSignup: false,
      loginWithoutBtn: false,
      login: {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      forgot: {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: '',
        otpType : ''
      },
      otp: {
        username: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: ''
      },
      signup: {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code')? this.$localStorage.get('ref_code') :'',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      },
      disabled: {
        from: new Date()
      },
      appointmentLogin: false,
      referralCodeDisable: false
    }
  },
  beforeCreate () {
    this.appointmentLogin = false
  },
  created () {
    if (this.$route.params.referralCode) {
      try {
        this.signup.referralCode = this.$route.params.referralCode.toUpperCase()
        setTimeout(function () {
          $('.signup').modal('show')
          this.referralCodeDisable = true
        }.bind(this), 1000)
      } catch (err) {
        this.signup.referralCode = ''
        setTimeout(function () {
          $('.signup').modal('show')
        }.bind(this), 1000)
      }
    }
    if (this.$route.fullPath === '/login') {
      if(this.$localStorage.get('profile') && this.$localStorage.get('profile') !== null) {
          this.$router.push({ path: '/myresult' })
          return false
      }
      setTimeout(function () {
        $('.login-box').modal('show')
      }, 1000)
    }    
  },
  mounted: function () {
    this.$root.$on('appointmentLogin', (isAppointment) => {
      this.appointmentLogin = true
    })
    this.$root.$on('loginClicked', (isAppointment) => {
      this.clearFields()
      this.errors.items = []
    })
  },
  watch :{
    'signup.referralCode' : function(){
        this.signup.referralCode = this.signup.referralCode.toUpperCase()
    }
  },
  methods: {
    loginWithOtpChanged: function (resend) {
      if (this.login.username === '') {
        this.$refs.login_username.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login').then((result) => {
        if (result) {
          if (this.login.username !== '') {
            let data = {
                'mobile': this.login.username
              }
              Promise.resolve(this.$POST('patient/sendOTP', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.login['otp_send'] = 2
                  this.login['error'] = false
                  this.login['errormsg'] = ''
                  if(resend) {
                    this.login['successmsg'] = 'We have resend an OTP to your mobile number.'
                  }else {
                    this.login['successmsg'] = 'We have send an OTP to your mobile number.'
                  }
                  
                  this.login['login_otp'] = ''
                  console.log(this.login)
                } else {
                  this.login['otp_send'] = 1
                  this.login['error'] = true
                  this.login['errormsg'] = res.response_message
                  this.login['successmsg'] = ''
                  this.login['login_otp'] = ''
                }
              }.bind(this)).catch(function (err) {
                console.log('METHOD:forgetPassword', err)
              })
          }
        }
      })
    },
    verifyLoginOTP: function () {
      if (this.login.login_otp === '') {
        this.$refs.login_otp.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login-wt-otp').then((result) => {
        if (result) {
          if (this.login.username !== '' && this.login.login_otp !== '') {
            this.$verifyLoginOTP(this.login.username, this.login.login_otp).then(function (response) {
              console.log(response)
              if (response.error) {
                this.login.error = true
                this.login.errormsg = 'Invalid OTP'
                this.login.successmsg = ''
                return false
              } else {
                this.login.error = false
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                })
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide')
                  $('.forgot').modal('show')
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  this.$router.push('/address')
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    this.$router.push({ path: '/myresult' })
                  }
                }
                return false
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    getNumberOfDays: function () {
      if (this.signup.year && this.signup.year !== '' && this.signup.month && this.signup.month !== '') {
        let noOfDays = new Date(this.signup.year, this.signup.month, 0).getDate()
        let dobDate = []
        for (var j = 1; j <= noOfDays; j++) {
          dobDate.push(j.toString())
        }
        this.signup['dobDate'] = dobDate

        if (this.signup.ddate) {
          var res = true
          dobDate.forEach(function (dataV) {
            if (parseInt(dataV) === parseInt(this.signup.ddate)) {
              res = false
            }
          }.bind(this))
          if (res) {
            this.signup.ddate = ''
          }
        }
      }
      return false
    },
    loginClicked: function () {
      this.login.error = false
      if(this.login.login_with_otp) {
        this.loginWithOtpChanged()
      } else {
        this.logon()
      }
    },
    logon: function () {
      if (this.login.username === '') {
        this.$refs.login_username.focus()
      } else if (this.login.password === '') {
        this.$refs.login_password.focus()
      }
      this.login.error = false
      this.$validator.validateAll('login').then((result) => {
        if (result) {
          if (this.login.username !== '' && this.login.password !== '') {
            this.$logon(this.login.username, this.login.password).then(function (response) {
              if (response.error) {
                this.login.error = true
                this.login.errormsg = response.error
                return false
              } else {
                Vue.analytics.fbq.event('ViewContent', {
                  content_ids: 0,
                  content_name: 'LOGIN SUCCESS',
                  contents: '',
                  content_type: 'LOGIN_SUCCESS'
                })
                if (response.data && response.data.isFirst === 1) {
                  $('.login-box').modal('hide')
                  $('.forgot').modal('show')
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  this.$router.push('/address')
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  $('.login-box').modal('hide')
                  if (this.$route.fullPath === '/login' || this.$route.fullPath === '/') {
                    this.$router.push({ path: '/myresult' })
                  }
                }
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    forgetPassword: function () {
      this.forgot.error = false
      this.$validator.validateAll('forgot').then((result) => {
        if (result) {
          try {
            if (this.forgot.username !== '') {
              let data = {}
              if (this.forgot.otpType == 2) {
                data = {
                  mobile: this.forgot.username,
                  otpType : this.forgot.otpType
                }
              } else {
                data = {
                  email: this.forgot.username,
                  otpType : this.forgot.otpType
                }
              }
              Promise.resolve(this.$POST('patient/forgetPassword', data)).then(function (res) {
                if (res.response_code === 0) {
                  this.forgot.error = false
                  this.forgot.errormsg = ''
                  this.forgot.success = 2
                  if(this.forgot.otpType == 2) {
                    this.forgot.successmsg = 'We have send an OTP to your mobile number.'
                  } else {
                    this.forgot.successmsg = 'We have send an authentication code to your mail id.'
                  }
                  
                } else {
                  this.forgot.success = 1
                  this.forgot.error = true
                  this.forgot.errormsg = res.response_message
                  this.forgot.otp = ''
                }
              }.bind(this)).catch(function (err) {
                console.log('METHOD:forgetPassword', err)
              })
            }
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    verify_otp: function () {
      this.$validator.validateAll('forgotOtp').then((result) => {
        if (result) {
          if (this.forgot.otpType == 2) {
            if (this.forgot.username !== '' && this.forgot.otp !== '') {
              this.$verifyLoginOTP(this.forgot.username, this.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true
                  this.forgot.errormsg = 'Invalid OTP'
                  this.forgot.successmsg = ''
                  return false
                } else {
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          } else {
            if (this.forgot.username !== '' && this.forgot.otp !== '') {
              this.$verifyOTP(this.forgot.username, this.forgot.otp).then(function (response) {
                if (response.error) {
                  this.forgot.error = true
                  this.forgot.errormsg = 'Invalid OTP'
                  this.forgot.successmsg = ''
                  return false
                } else {
                  this.forgot.error = false
                  this.forgot.success = 3
                  return false
                }
              }.bind(this)).catch(function (err) {
                console.error(err)
              })
            }
          }
        }
      })
    },
    reset_password: function () {
      if (this.forgot.newPassword !== this.forgot.confirmPassword) {
        return false
      }
      this.$validator.validateAll('resetPassword').then((result) => {
        if (result) {
          if (this.forgot.newPassword !== '' && this.forgot.confirmPassword !== '') {
            this.$resetPassword(this.forgot.newPassword).then(function (response) {
              if (response.error) {
                this.forgot.error = true
                this.forgot.errormsg = 'Invalid User'
                this.forgot.successmsg = ''
                return false
              } else {
                if(this.$route.fullPath === '/referral/login') {
                  $('.forgot').modal('hide')
                  this.$router.push('/referral/invite')
                  return false
                }
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.forgot').modal('hide')
                  this.$router.push('/address')
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  $('.forgot').modal('hide')
                  return false
                }
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    resend: function () {
      try {
        if (this.forgot.username !== '') {
          let data = {
            'email': this.forgot.username,
            otpType : this.forgot.otpType
          }
          Promise.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.forgot.error = false
              this.forgot.errormsg = ''
              this.forgot.success = 2
              if(this.forgot.otpType == 2) {
                this.forgot.successmsg = 'We have resend an OTP to your mobile number.'
              } else {
                this.forgot.successmsg = 'We have resend an authentication code to your mail id.'
              }
            } else {
              this.forgot.success = 1
              this.forgot.error = true
              this.forgot.errormsg = res.response_message
              this.forgot.otp = ''
            }
          }.bind(this)).catch(function (err) {
            console.log('METHOD:forgetPassword', err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    clearFields: function (type) {
      if (type === 1) {
        Vue.analytics.fbq.event('ViewContent', {
          content_ids: 0,
          content_name: 'SIGN UP CLICKED',
          contents: '',
          content_type: 'SIGNUP_CLICK'
        })
      }
      this.isDobError = false
      this.signup = {
        email: '',
        mobile: '',
        name: '',
        password: '',
        referralCode: this.$localStorage.get('ref_code') ? this.$decryptString(this.$localStorage.get('ref_code')) : '',
        dob: undefined,
        sex: 'M',
        otp: '',
        error: false,
        errormsg: '',
        success: false,
        successmsg: '',
        dobYears: [],
        dobDate: [],
        year: '',
        month: '',
        ddate: ''
      }
      this.referralCodeDisable = false
      this.login = {
        username: '',
        password: '',
        error: false,
        errormsg: '',
        otp_send: 1,
        login_otp: '',
        successmsg: ''
      },
      this.forgot = {
        username: '',
        otp: '',
        newPassword: '',
        confirmPassword: '',
        error: false,
        errormsg: '',
        success: 1,
        successmsg: ''
      }
      let year = (new Date()).getFullYear()
      let endYear = year - 120
      var dobYears = []
      for (let i = year; i > endYear; i--) {
        dobYears.push(i.toString())
      }
      this.signup['dobYears'] = dobYears

      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 200)
      setTimeout(function () {
        document.body.classList.add('modal-open')
      }, 1000)
    },
    create_account: function () {
      this.isDobError = false
      this.signup.error = false
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          // if (this.signup.year.length !== 4 || this.signup.month.length <= 0 || this.signup.ddate.length <= 0) {
          //   this.isDobError = true
          //   return false
          // }
          try {
            if (this.signup.email !== '' && this.signup.mobile !== '' && this.signup.firstName !== '' && this.signup.password !== '') {
              let params = {
                'firstName': this.signup.firstName,
                'lastName': '',
                'phone1': this.signup.mobile,
                'email': this.signup.email,
                'password': this.signup.password,
                'referralCode': this.signup.referralCode,
                // 'sex': this.signup.sex,
                'sex': '',
                // 'dob': this.signup.year + '-' + this.signup.month + '-' + this.signup.ddate,
                'dob': null
                // 'dob': dateFormat(this.signup.dob, 'yyyy-mm-dd', true)
              }
              Promise.resolve(this.$POST('patient/quickSignUp', params)).then(function (response) {
                if (response.response_code === 0) {
                  this.signup.error = false
                  this.signup.errormsg = ''
                  this.signup.success = true
                  this.signup.successmsg = 'We have send an authentication code for verifying your account.'
                  Vue.analytics.fbq.event('ViewContent', {
                    content_ids: 0,
                    content_name: 'SIGN UP SUCCESS',
                    contents: '',
                    content_type: 'SIGNUP_SUCCESS'
                  })
                } else {
                  this.signup.success = false
                  this.signup.error = true
                  this.signup.errormsg = response.response_message
                  this.signup.otp = ''
                  if(response.response_code === 3) {
                      this.$refs.signUpEmail.focus()
                    } else if(response.response_code === 4) {
                      this.$refs.signUpMobile.focus()
                    }
                }
              }.bind(this)).catch(function (err) {
                console.log(err)
              })
            } else {
              this.$Simplert.open({
                title: 'Alert',
                message: `Please enter required fields!`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              })
              // alert('Please enter required fields!')
            }
          } catch (e) {
            console.error(e)
          }
        }
      }.bind(this))
    },
    signup_verify_otp: function () {
      this.$validator.validateAll('signupOtp').then((result) => {
        if (result) {
          if (this.signup.email !== '' && this.signup.otp !== '') {
            this.$verifyOTP(this.signup.email, this.signup.otp).then(function (response) {
              if (response.error) {
                this.signup.error = true
                this.signup.errormsg = 'Invalid OTP'
                this.signup.successmsg = ''
                return false
              } else {
                if (this.appointmentLogin) {
                  this.appointmentLogin = false
                  this.$root.$emit('isLogin', true)
                  $('.signup').modal('hide')
                  this.$router.push('/address')
                  // location.reload()
                  return false
                } else {
                  this.$root.$emit('isLogin', true)
                  $('.signup').modal('hide')
                  // location.reload()
                }
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          }
        }
      })
    },
    signup_resend: function () {
      try {
        if (this.signup.email !== '') {
          let data = {
            'email': this.signup.email
          }
          Promise.resolve(this.$POST('patient/resendOTP', data)).then(function (res) {
            if (res.response_code === 0) {
              this.signup.error = false
              this.signup.errormsg = ''
              this.signup.success = true
              this.signup.successmsg = 'We have resend an authentication code to your mail id.'
            } else {
              this.signup.success = false
              this.signup.error = true
              this.signup.errormsg = res.response_message
              this.signup.otp = ''
            }
          }.bind(this)).catch(function (err) {
            console.log(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    logout: function () {
      this.$clearLocalStorage()
      location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.close, .btn {
    cursor: pointer;
}
.red {
  color: red !important
}
a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Login.vue